<template>
    <cart-widget-toggle-base>
        <template slot-scope="{ count, toggle }">
            <button
                class="cart-widget-toggle btn btn-primary"
                @click="toggle"
            >
                <span class="button-caption">
                    <i class="fa fa-shopping-cart" />
                </span>
                <span class="button-value">{{ count }}</span>
            </button>
        </template>
        <cart-widget-toggle-base />
    </cart-widget-toggle-base>
</template>

<script>
export default {}
</script>

